import { API_BASE_URL, getBaseHeaders } from './api.config';
import { throwApiError } from './api.error';
import { Category, PaginatedResponse } from './api.types';

export type CategoriesResponse = PaginatedResponse<Category>;

export const fetchCategories = async (): Promise<CategoriesResponse> => {
  const response = await fetch(
    `${API_BASE_URL}/categories/search?page=1&size=20&sortField=PRIORITY&order=ASC`,
    {
      method: 'POST',
      headers: {
        ...getBaseHeaders(),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        ids: [],
        name: null
      })
    }
  );

  if (!response.ok) {
    await throwApiError(response);
  }

  return await response.json();
};
